import { hasSignInWithRedirectFailed, useSquareSignIn } from '@packages/cognito-auth/react';
import { INTEGRATION_LABELS } from '@packages/shared';
import { ActionButton } from '@/components/ActionButton';
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { track } from '@/lib/analytics';
import { env } from '@/lib/env';

/** admin-web's hosts for Square sellers, who sign up and in with Square only. */
const SQUARE_HOSTNAMES = ['square.zestordering.com', 'square.sta.zestordering.com'];

export const isSquareSignIn = () =>
  SQUARE_HOSTNAMES.includes(window.location.hostname) ||
  // Dev has no Square host, so `?type=square` stands in for one. Square's sign-in comes back to
  // `/`, so a failed one shows its page again, with the error.
  (env.VITE_STAGE === 'dev' &&
    (new URLSearchParams(window.location.search).get('type') === 'square' ||
      hasSignInWithRedirectFailed()));

export const SquareSignIn = () => {
  const { isLoading, userVisibleError, signInWithSquare } = useSquareSignIn();

  const handleSignIn = async () => {
    track('clicked_sign_in', { signup_method: 'SQUARE' });
    await signInWithSquare();
  };

  return (
    <Card className="w-[320px]">
      <CardHeader>
        <CardTitle className="text-xl">Login</CardTitle>
      </CardHeader>
      <CardContent>
        <ActionButton
          className="w-full"
          disabled={isLoading}
          loading={isLoading}
          onClick={handleSignIn}
        >
          Continue with {INTEGRATION_LABELS.SQUARE}
        </ActionButton>
      </CardContent>
      {(userVisibleError || hasSignInWithRedirectFailed()) && (
        <CardFooter>
          <div className={'text-red-500 dark:text-red-400'}>
            {userVisibleError || `${INTEGRATION_LABELS.SQUARE} didn't let you sign in. Try again.`}
          </div>
        </CardFooter>
      )}
    </Card>
  );
};
